import {
  aboutUs,
  backmarketWarranty,
  blackFriday,
  boMerchant,
  buyBack,
  buyingGuides,
  cookiePolicy,
  dataProtection,
  giftCards,
  giftFinder,
  help,
  hireExternal,
  infosConsumer,
  insurances,
  legal,
  modelsComparison,
  studentGoodDeals,
  termsBuyback,
  termsSale,
  termsUse,
} from './shared-links'
import type { FooterConfig } from './types'

export const gbConfig: FooterConfig = {
  columns: [
    {
      titleKey: 'categoryAbout',
      links: [
        aboutUs,
        {
          translationKey: 'press',
          href: '/en-gb/about-us#scroll=false&target=heading-2-press-kit',
        },
        {
          translationKey: 'impact',
          href: '/en-gb/about-us#scroll=false&target=heading-2-our-impact-report',
        },
        hireExternal,
        {
          translationKey: 'trustpilot',
          href: 'https://www.trustpilot.com/review/www.backmarket.co.uk',
        },
      ],
      socials: [
        { name: 'instagram', href: 'https://www.instagram.com/backmarket' },
        { name: 'tiktok', href: 'https://www.tiktok.com/@backmarket' },
        {
          name: 'youtube',
          href: 'https://www.youtube.com/channel/UCeyWJxApnbMPhzOjAftCGeg',
        },
        { name: 'facebook', href: 'https://www.facebook.com/backmarket' },
        { name: 'x', href: 'https://x.com/backmarket' },
      ],
    },
    {
      titleKey: 'categoryHelp',
      links: [
        {
          translationKey: 'contactUs',
          href: 'https://help.backmarket.com/hc/en-gb/articles/360026654654-How-do-I-contact-Back-Market-Customer-Care',
        },
        help,
        {
          translationKey: 'shipping',
          href: 'https://help.backmarket.com/hc/en-gb/articles/360026646054-Where-can-I-get-delivered-and-how-much-does-it-cost-me',
        },
        {
          translationKey: 'return',
          href: 'https://help.backmarket.com/hc/en-gb/categories/360002106194-Returns-refunds--Vr%C3%A1tenie-objedn%C3%A1vky-a-pe%C5%88az%C3%AD-%CE%95%CF%80%CE%B9%CF%83%CF%84%CF%81%CE%BF%CF%86%CE%AD%CF%82-%CE%91%CF%80%CE%BF%CE%B6%CE%B7%CE%BC%CE%B9%CF%8E%CF%83%CE%B5%CE%B9%CF%82-Reso-del-prodotto-e-rimborsi-Returns-Refunds--Retours-Remboursements-Retouren-en-terugbetalingen-Returns-refunds-',
        },
      ],
    },
    {
      titleKey: 'categoryServices',
      links: [
        backmarketWarranty,
        insurances,
        buyBack,
        studentGoodDeals,
        {
          translationKey: 'becomeRefurbisher',
          href: 'https://backmarket.co.uk/en-gb/seller/home',
        },
        boMerchant,
      ],
      payment: {
        translationKey: 'paymentMethods',
        href: 'https://help.backmarket.com/hc/en-gb/articles/360026643854-What-payment-methods-are-accepted-on-Back-Market',
      },
    },
    {
      titleKey: 'categoryGuides',
      links: [
        giftCards,
        buyingGuides,
        modelsComparison,
        giftFinder,
        blackFriday,
      ],
    },
    {
      titleKey: 'categoryLaw',
      links: [
        termsUse,
        termsSale,
        termsBuyback,
        cookiePolicy,
        dataProtection,
        infosConsumer,
        legal,
        {
          translationKey: 'illegalContent',
          href: 'https://help.backmarket.com/hc/en-gb/requests/new?ticket_form_id=12226993197084',
        },
      ],
    },
    {
      logos: ['bcorp'],
    },
  ],
}
